import SVG from "react-inlinesvg";
import { getCompanyDetails } from "utils";

import { CountryCode } from "@krea/shared/types/common";
import { cn } from "@krea/shared/utils";

import { useGetCurrentLenderCompanyQuery } from "@/features/lender-companies/hooks/use-get-lender-company.query";

import LogoKrea from "../../static/images/svg/logo/krea.svg";
import LogoKredita from "../../static/images/svg/logo/kredita.svg";

export const Footer = ({ className }: { className?: string }) => {
  const { data: lenderCompany } = useGetCurrentLenderCompanyQuery();
  const countryCode = lenderCompany?.countryCode;
  const contacts = getCompanyDetails(countryCode ?? CountryCode.SE);

  return (
    <footer className={cn("w-full py-8 px-4 sm:px-4", className)}>
      <div className="mx-auto flex max-w-full flex-col flex-wrap items-start justify-between gap-8 lg:flex-row xl:gap-12">
        {/* Logo & about */}
        <div className="shrink-0">
          {countryCode === CountryCode.SE && (
            <div className="relative mb-4 w-24">
              <SVG className="h-auto w-full" src={LogoKrea} />
            </div>
          )}
          {countryCode === CountryCode.FI && (
            <div className="relative mb-4 w-24">
              <SVG className="h-auto w-full" src={LogoKredita} />
            </div>
          )}
          <ul className="m-0 list-none text-helper">
            <li>Krea Technology AB</li>
            <li>Org.nr: 559173-2895</li>
          </ul>
        </div>

        {/* Contact */}
        <div className="shrink-0">
          <h6 className="mb-4 uppercase text-label">Contact us</h6>
          <dl className="m-0 space-y-1">
            {contacts.phone?.link && contacts.phone.number && (
              <div className="flex gap-2">
                <dt className="m-0">Phone:</dt>
                <dd className="m-0">
                  <a href={`tel:${contacts.phone.link}`}>
                    {contacts.phone.number}
                  </a>
                </dd>
              </div>
            )}
            {contacts.email && (
              <div className="flex gap-2">
                <dt className="m-0">E-mail:</dt>
                <dd className="m-0">
                  <a href={`mailto:${contacts.email}`}>{contacts.email}</a>
                </dd>
              </div>
            )}
            {contacts.address?.title && contacts.address.link && (
              <div className="flex gap-2">
                <dt className="m-0">Address:</dt>
                <dd className="m-0">
                  <a
                    href={contacts.address.link}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    {contacts.address.title}
                  </a>
                </dd>
              </div>
            )}
          </dl>
        </div>

        {/* Opening hours */}
        <div className="shrink-0">
          <h6 className="mb-4 uppercase text-label">Opening hours</h6>
          <dl className="m-0 space-y-1">
            {contacts.openingHours?.map((item, index) => (
              <div
                key={index}
                className="flex justify-between gap-4 xl:justify-start"
              >
                <dt className="m-0">{item.day}:</dt>
                <dd className="m-0">{item.time}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </footer>
  );
};
